












import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * Small support component which renders a button which change its appearance depending on the screen size
 */
@Component({})
export default class ResponsiveButtonComponent extends Vue {
    @Prop()
    public text!: string;

    @Prop()
    public icon!: string;

    @Prop()
    public responsiveContentClass!: string;

    @Prop()
    public contentClass!: string;

    /**
     *  Returns the given classes according to the current state.
     */
    get currentClass(): string {
        return this.hasResponsiveState ? this.responsiveContentClass : this.contentClass;
    }

    /**
     * Determines if only text should be displayed
     */
    get hasResponsiveState(): boolean {
        return this.$vuetify.breakpoint.smAndDown;
    }
}
